import { call, takeLatest } from 'redux-saga/effects';

import printJS from 'print-js';
import { INFORMES_IMPRIMIR_START } from '../actions/constants/informes.constants';
import request, { authRequest } from '../../helpers/request.helper';
import { isTablet } from '../../helpers/device.helper';

function* descargarInformes({ payload }) {
  const { informeId, plantillaId, parametros } = payload;

  const params = {
    url: 'api/security/obteneraccesoget',
    method: 'POST',
    body: {
      parametros_informe: {
        ...parametros,
      },
      informe_id: informeId,
      plantilla_id: plantillaId,
    },
  };
  const respuestaToken = yield call(authRequest, params);

  const { token_b64: tokenb64 } = respuestaToken;
  const url = `${window.GIO_CONFIG.API_URL}/informe/imprimir/${tokenb64}`;

  if (isTablet()) {
    const paramsInformes = {
      url,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/octet-stream',
        Accept: 'application/octet-stream',
      },
    };
    const respuestaInforme = yield call(request, paramsInformes);
    const blobUrl = URL.createObjectURL(new Blob([respuestaInforme], { type: 'application/pdf' }));
    window.open(blobUrl, '_blank');
  } else {
    yield printJS({
      printable: url,
      type: 'pdf',
      onIncompatibleBrowser: () => {
      },
      onLoadingEnd: () => {

      },
      onError() {
      },
    });
  }
}

function* informesSaga() {
  yield takeLatest(INFORMES_IMPRIMIR_START, descargarInformes);
}

export default informesSaga;
